import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';

// Context
import { ThemeProvider } from './contexts/ThemeContext';

// Pages
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import TvPage from './pages/TvPage';

// Components
import Header from './components/Header';
import Footer from './components/Footer';

function AppLayout() {
  const location = useLocation();
  const isTvRoute = location.pathname === '/tv';

  return (
    <div className={`App ${isTvRoute ? 'app-tv' : ''}`}>
      <Header />
      <main className={isTvRoute ? 'main-tv' : ''}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/tv" element={<TvPage />} />
          <Route path="/hakkimizda" element={<AboutPage />} />
          <Route path="/iletisim" element={<ContactPage />} />
        </Routes>
      </main>
      {!isTvRoute && <Footer />}
    </div>
  );
}

function App() {
  useEffect(() => {
    // Scroll performansı optimizasyonları
    const optimizeScroll = () => {
      // Smooth scrolling için CSS scroll-behavior kullanılıyor
      // GPU hızlandırma için transform3d kullanılıyor
      
      // Scroll event listener'ları optimize et
      let ticking = false;
      
      const handleScroll = () => {
        if (!ticking) {
          requestAnimationFrame(() => {
            // Scroll işlemleri burada yapılabilir
            ticking = false;
          });
          ticking = true;
        }
      };
      
      window.addEventListener('scroll', handleScroll, { passive: true });
      
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    };
    
    optimizeScroll();
  }, []);

  return (
    <ThemeProvider>
      <Router>
        <AppLayout />
      </Router>
    </ThemeProvider>
  );
}

export default App;
